<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-15 14:13:14
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 23:27:06
-->

<template>
  <section>
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <div class="topic-outer xq_common_text">
      <div
          class="appraisal-center fonts tab_info_casertyudsad"
          v-for="(item, index) in realItem"
          :key="index"
      >
        <div class="xq_common_textTitle">{{ emptyShow(item.con) }}</div>
        <div class="innner">
          <el-row v-if="item.index == 1">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单号:</span> {{ emptyShow(detailData.examOrder.orderNumber) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>名称:</span> {{ emptyShow(detailData.extraOrder.orderTitle) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主题:</span> {{ emptyShow(detailData.examOrder.subject) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单金额:</span>
                $ {{ emptyShow(detailData.extraOrder.payMoney) / 100 }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{ emptyShow(detailData.examOrder.paymentType) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <span style="color: #409eff" v-if="detailData.examOrder.payStatus == 0">待支付</span>
                <span style="color: #409eff" v-if="detailData.examOrder.payStatus == 10">支付成功</span>
                <span style="color: #409eff" v-if="detailData.examOrder.payStatus == 20">退款中</span>
                <span style="color: #409eff" v-if="detailData.examOrder.payStatus == 25">退款完成</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ emptyShow(detailData.examOrder.ctime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>完成时间:</span>
                {{ emptyShow(detailData.examOrder.payTime) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 2">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ emptyShow(detailData.examOrder.nickName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>国家编码:</span> {{ emptyShow(detailData.examOrder.countryCode) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>邮箱:</span> {{ emptyShow(detailData.examOrder.email) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span> {{ detailData.examOrder.sex == 1 ? '男':'女' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>出生日期:</span> {{ emptyShow(detailData.examOrder.age) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>语言:</span> {{ emptyShow(detailData.examOrder.languageCode) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>设备标识:</span> {{ emptyShow(detailData.examOrder.deviceId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户IP:</span> {{ emptyShow(detailData.examOrder.ip) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 3">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属应用:</span>
                <span>
                  {{ emptyShow(detailData.appInfoVo).appName }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属渠道:</span>
                {{ emptyShow(detailData.channelAccountVo).name }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付商户:</span>
                {{ emptyShow(detailData.paymentMchVo).mchName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>投放方式:</span> {{ emptyShow(detailData.putWayName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主体:</span>
                {{ emptyShow(detailData.channelMchVo).name }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 4">
            <el-table
                :data="detailData.orderpays"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="事件"
                  prop="payTypeName"
              ></el-table-column>
              <el-table-column
                  label="流水号"
                  prop="payCode"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="支付金额" prop="payMoney">
                <template slot-scope="scope">
                  ${{ emptyShow(scope.row.orderMoney) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="支付方式" prop="paymentType" width="120">
              </el-table-column>
              <el-table-column
                  label="支付状态"
                  prop="payStatusName"
              ></el-table-column>
              <el-table-column label="归属商户" prop="mchName" width="120">
              </el-table-column>
              <el-table-column
                  label="创建时间"
                  prop="ctime"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  label="成功时间"
                  prop="finishTime"
                  min-width="160"
              ></el-table-column>
              <el-table-column fixed="right" label="操作" min-width="240">
                <template slot-scope="scope">
                  <!-- <span v-for="(item,i) in scope.row.detail" :key="i" style="text-align: left;white-space:nowrap;"> -->
                  <el-tooltip
                      placement="top"
                      popper-class="testtooltip"
                      effect="light"
                  >
                    <div
                        slot="content"
                        v-if="
                        emptyShow(scope.row.orderPayVos) &&
                        emptyShow(scope.row.orderPayVos).orderPayNotifyVos!=undefined
                      "
                    >
                      <h5>回调信息</h5>
                      <p>
                        支付ID：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).exportId
                        }}
                      </p>
                      <p>
                        支付账号：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos).exportAccount
                        }}
                      </p>
                      <p>
                        收款ID：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).enterId
                        }}
                      </p>
                      <p>
                        收款账号：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).enterAccount
                        }}
                      </p>
                      <p>
                        回调时间：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).ctime
                        }}
                      </p>
                      <br/>
                    </div>
                    <div v-else slot="content">暂无回调信息</div>
                    <span>
                      <el-button
                          type="primary"
                          plain
                          size="small"
                          @click="visible = true"
                      >回调信息</el-button
                      >
                    </span>
                  </el-tooltip>
                  <!-- </span> -->
                  <template v-if="userInfo && userInfo.operateStatus==1">
                    <template v-if="scope.row.payStatus == 10">
                      <el-button
                          @click="reFund(scope.row)"
                          type="danger"
                          size="small"
                          style="margin-left: 20px"
                          v-if="numType"
                      >退款
                      </el-button
                      >
                      <el-button
                          style="margin-left: 20px"
                          @click="operationShowTime"
                          type="danger"
                          size="small"
                          v-else
                      >退款
                      </el-button
                      >
                    </template>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>
      </div>
      <operation-confirmation @closeOperation="publicMethios"
                              :operationVisible="operationVisible"></operation-confirmation>
    </div>
  </section>
</template>

<script>
// import itemsDetail from "../layout/components/itemsDetail.vue";

import {isEmpty, emptyShow} from "../../utils/tools/index";
import OperationConfirmation from "../../components/OperationConfirmation";
import {
  PAGE_SIZE,
} from "@/config";

export default {
  components: {
    // itemsDetail,
    OperationConfirmation
  },
  data() {
    return {
      PAGE_SIZE,
      //分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      countList: 0,
      emptyShow,
      isEmpty,
      id: "",
      realItem: [], //展示信息模块
      title: "",
      detailData: [],
      loading: false,
      operationVisible: false,
      numType: false,
      tableData: [],
    };
  },
  activated() {
    this.getOrgData();
  },
  created() {
    if (window.sessionStorage.getItem('operationKey')) {
      this.numType = true
    }
    this.getOrgData();
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    $route(to, form) {
      if (to.query.value) {
        let toOrderNum = JSON.parse(to.query.value)
        let formOrderNum = JSON.parse(form.query.value)
        if (toOrderNum != formOrderNum) {
          this.getOrgData();
        }
      }
    }
  },
  methods: {
    //关闭
    publicMethios(e) {
      this.operationVisible = false
      if (e == 'open') {
        this.numType = true
        setTimeout(() => {
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        }, 1800000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e) {
      this.operationVisible = true
    },

    //订单详情
    getOrderDetail(row) {
      if (row.bizType == 'vip') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 1,
            title: '会员订单',
            key: 'orderNumber',
            value: JSON.stringify(row.orderNumber),
            path: '/vip/order/info',
          }
        })
      } else if (row.bizType == 'exam') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 0,
            title: '测评订单',
            key: 'orderNumber',
            value: JSON.stringify(row.orderNumber),
            path: '/exam/order/info',
          }
        })
      } else if (row.bizType == 'pay') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 2,
            title: '支付订单',
            key: 'payCode',
            value: JSON.stringify(row.orderNumber),
            path: '/pay/order/info',
          }
        })
      } else if (row.bizType == 'znqm' || row.bizType == 'zncm' || row.bizType == 'znys' || row.bizType == 'zwds' || row.bizType == 'znhp') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 4,
            title: '国学订单',
            key: 'orderNumber',
            orderKey: 'bizType',
            value: JSON.stringify(row.orderNumber),
            Typevalue: JSON.stringify(row.bizType),
            path: '/guoxue/order/info',
          }
        })
      } else if (row.bizType == 'zncm') {

      } else if (row.bizType == 'gsqm') {

      } else if (row.bizType == 'taluo') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 5,
            title: '塔罗订单',
            key: 'orderNumber',
            value: JSON.stringify(row.orderNumber),
            path: '/tarot/order/info',
          }
        })
      }
    },

    goDetails(e) {
      if (e.bizType == 'vip') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 1,
            title: '会员订单',
            key: 'orderNumber',
            value: JSON.stringify(e.orderNumber),
            path: '/vip/order/info',
          }
        })
      } else if (e.bizType == 'znqm' || e.bizType == 'zncm' || e.bizType == 'znys' || e.bizType == 'zwds' || e.bizType == 'znhp') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 4,
            title: '国学订单',
            key: 'orderNumber',
            orderKey: 'bizType',
            value: JSON.stringify(e.orderNumber),
            Typevalue: JSON.stringify(e.bizType),
            path: '/guoxue/order/info',
          }
        })
      } else if (e.bizType == 'taluo') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 5,
            title: '塔罗订单',
            key: 'orderNumber',
            value: JSON.stringify(e.orderNumber),
            path: '/tarot/order/info',
          }
        })
      }else if(e.bizType == 'exam'){
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 0,
            title: '测评订单',
            key: 'orderNumber',
            value: JSON.stringify(e.orderNumber),
            path: '/exam/order/info',
          }
        })
      } else if (e.bizType == 'pay') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 2,
            title: '支付订单',
            key: 'payCode',
            value: JSON.stringify(e.orderNumber),
            path: '/pay/order/info',
          }
        })
      }
    },
    /* 返回上一页 */
    goBack() {
      this.$router.go(-1);
    },
    /* 接收参数并获取初始值 */
    async getOrgData() {
      this.id = this.$route.query.id;
      let items = {
        fir: [
          {index: 1, con: "订单信息"},
          {index: 2, con: "用户信息"},
          {index: 3, con: "业务信息"},
          {index: 4, con: "支付信息"},
        ],
        sec: [
          {index: 1, con: "支付信息"},
          {index: 2, con: "回调信息"},
          {index: 3, con: "用户信息"},
          {index: 4, con: "业务信息"},
        ],
        thir: [
          {index: 1, con: "用户信息"},
          {index: 2, con: "账号信息"},
          {index: 3, con: "使用信息"},
          {index: 4, con: "注册信息"},
        ],
        sexThre: [
          {index: 1, con: "用户信息"},
          {index: 2, con: "账号信息"},
          {index: 3, con: "使用信息"},
          {index: 4, con: "注册信息"},
          {index: 5, con: "订单列表"},
        ],
      };
      switch (Number(this.id)) {
        case 0:
          this.realItem = items.fir;
          break;
        case 1:
          this.realItem = items.fir;
          break;
        case 2:
          this.realItem = items.sec;
          break;
        case 3:
          this.realItem = items.thir;
          break;
        case 4:
          this.realItem = items.thir;
          break;
        case 5:
          this.realItem = items.thir;
          break;
        case 6:
          this.realItem = items.sexThre;
          break;
        default:
          break;
      }
      this.title = this.$route.query.title;
      if (Number(this.id) == 4) {
        const {data: res} = await this.$get(
            `${this.$route.query.path}?${this.$route.query.key}=${JSON.parse(
                this.$route.query.value
            )}&${this.$route.query.orderKey}=${JSON.parse(
                this.$route.query.Typevalue
            )}`
        );
        if (res.data) this.detailData = res.data;

      } else {
        const {data: res} = await this.$get(
            `${this.$route.query.path}?${this.$route.query.key}=${JSON.parse(
                this.$route.query.value
            )}`
        );
        if (res.data) this.detailData = res.data;
      }
      if (this.$route.query.key == 'userId') {
        this.getUserInfoOrder()
      }
    },

    async getUserInfoOrder() {
      this.loading = true;
      const {data: res} = await this.$get('/kefu/user/order/list?pageNo='+this.page.pageNo+'&pageSize='+this.page.pageSize+'&userId=' + JSON.parse(
          this.$route.query.value
      ));
      this.loading = false
      if (res.data) {
        let list = res.data
        if (list) {
          list.forEach((item) => {
            item.orderMoney = item.orderMoney / 100
            item.payMoney = item.payMoney / 100
          })
        }
        this.tableData = list;
        this.countList = res.page.count;
      } else {
        this.tableData = []
        this.countList = 0
      }
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getUserInfoOrder();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getUserInfoOrder();
    },


    //tool hover框
    handleClose(index) {
      this.$refs[`popover-${index}`].doClose();
    },

    //reFund发起退款

    async tuikuanList(row) {
      let payCodes = row.payCode
      let payCode = {
        payCode: payCodes
      }
      this.$confirm("即将发起退款, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$message.success("您的订单正在退款中，请稍后.");
        const {data: resData} = await this.$post(
            "/order/refund/info",
            payCode,
        );
        this.$message.success(resData.message);
        if (resData.result != 200) return;
        this.getOrgData()
      });
    },
    reFund(row) {
      let payCodes = row.payCode
      let payCode = {
        payCode: payCodes
      }
      this.$confirm("即将发起退款, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$message.success("您的订单正在退款中，请稍后.");
        const {data: resData} = await this.$post(
            "/order/refund/info",
            payCode,
        );
        if (resData.result != 200) return;
        this.$message.success("退款成功!");
        this.getOrgData()
      });
    },
  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-table th,
::v-deep .el-table td {
  text-align: center !important;
}

::v-deep .el-page-header__content {
  font-size: 16px;
  color: #303133;
}

.topic-outer {
  width: 100%;
  overflow: hidden;
  margin-top: 10px;
  // padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-col {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .appraisal-center {
    margin: 20px 0;
    border-radius: 6px;
    background: #fff;
    padding: 30px 20px;

    .innner {
      padding: 20px 20px 0;

      .grid-content {
        color: #888;

        span:first-child {
          color: #444;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
//  箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: white !important;
}

// 箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: white !important;
}

// 内容
.testtooltip {
  background: white !important;
  box-shadow: 1px 1px 10px 3px #d3d3d6;
}
</style>
